import React, { useEffect, useState } from "react";
import L from "leaflet";
import { MapContainer, Marker, TileLayer, useMapEvent } from "react-leaflet";
import { Button } from "react-bootstrap";

export interface MapPickerProps {
  HandleSelect: (Lat: number, Lng: number) => void;
  Height?: number;
  Latitude?: number;
  Longitude?: number;
  Zoom?: number;
  ReadOnlyMap: boolean;
}
const Red_MARKER = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="80" height="94" viewBox="0 0 80 94" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_2835_39318)">
<path d="M59.543 34.2678C59.543 45.1873 39.7715 68.0001 39.7715 68.0001C39.7715 68.0001 20 45.1873 20 34.2678C20 23.3483 28.852 14.4963 39.7715 14.4963C50.691 14.4963 59.543 23.3483 59.543 34.2678Z" fill="#0069B3"/>
<circle cx="39.7725" cy="34.1397" r="9.10844" fill="white"/>
</g>
<defs>
<filter id="filter0_d_2835_39318" x="0" y="0.496338" width="79.543" height="93.5037" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="6"/>
<feGaussianBlur stdDeviation="10"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2835_39318"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2835_39318" result="shape"/>
</filter>
</defs>
</svg>
    `)}`;

const MapPicker = ({
  HandleSelect,
  Height,
  Latitude,
  Longitude,
  Zoom,
  ReadOnlyMap = false,
}: MapPickerProps) => {
  // 64, 26 = About Finland's center
  const [centerLat, setCenterLat] = useState<number>(64);
  const [centerLng, setCenterLng] = useState<number>(26);
  const [lat, setLat] = useState<number>(null);
  const [lng, setLng] = useState<number>(null);

  // Tallenna alkuper�iset koordinaatit
  const [initialLat, setInitialLat] = useState<number>(null);
  const [initialLng, setInitialLng] = useState<number>(null);

  const iconPerson = new L.Icon({
    iconUrl: Red_MARKER,
    iconAnchor: new L.Point(25, 25),
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: new L.Point(50, 50),
    className: "leaflet-div-icon",
  });

  const SetCoordinates = (Lat: number, Lng: number) => {
    // Jos alkuper�isi� koordinaatteja ei ole asetettu, aseta ne
    if (initialLat === null && initialLng === null) {
      setInitialLat(Lat);
      setInitialLng(Lng);
    }

    setLat(Lat);
    setLng(Lng);
    setCenterLat(Lat);
    setCenterLng(Lng);
    HandleSelect(Lat, Lng);
  };

  function ClickComponent() {
    useMapEvent("click", (e) => {
      if (ReadOnlyMap) return;
      SetCoordinates(e.latlng.lat, e.latlng.lng);
    });
    return null;
  }

  useEffect(() => {
    if (Latitude !== null && Longitude !== null) {
      setCenterLat(Latitude);
      setCenterLng(Longitude);
    }
  }, []);

  useEffect(() => {
    if (Latitude !== null && Longitude !== null) {
      SetCoordinates(Latitude, Longitude);
      setCenterLat(Latitude);
      setCenterLng(Longitude);
    }
  }, [Latitude, Longitude]);

  const [isDraggingEnabled, setIsDraggingEnabled] = useState(!ReadOnlyMap);

  const toggleDragging = () => {
    if (isDraggingEnabled) {
      // Palauta alkuper�iset koordinaatit
      if (initialLat !== null && initialLng !== null) {
        SetCoordinates(initialLat, initialLng);
      }
    }
    setIsDraggingEnabled(!isDraggingEnabled);
  };
  const handleDragEnd = (e) => {
    if (isDraggingEnabled) {
      SetCoordinates(e.target._latlng.lat, e.target._latlng.lng);
    }
  };

  const markerEventHandlers = isDraggingEnabled
    ? { dragend: handleDragEnd }
    : {};

  return (
    <div className="position-relative">
      {!ReadOnlyMap && (
        <Button
          onClick={toggleDragging}
          className="position-absolute z-3 m-8 translate-middle start-50 bottom-0"
          variant={isDraggingEnabled ? "primary" : "primary"}
        >
          {isDraggingEnabled ? "Peru" : "Muokkaa"}
        </Button>
      )}

      <MapContainer
        //TODO Center does not work without lat&lng
        center={[Latitude, Longitude]}
        zoom={Zoom}
        scrollWheelZoom
        style={{ height: Height }}
        className="z-2"
      >
        <ClickComponent />
        {lat !== null && lng !== null && (
          <Marker
            draggable={isDraggingEnabled}
            eventHandlers={markerEventHandlers}
            icon={iconPerson}
            position={[lat, lng]}
          />
        )}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          referrerPolicy="origin"
        />
      </MapContainer>
    </div>
  );
};

MapPicker.defaultProps = {
  Height: 500,
  Latitude: null,
  Longitude: null,
  Zoom: 6,
};

export default MapPicker;
export { MapPicker };
